<template>
  <div v-if="token" class="layout">
    <Sidebar />
    <div class="main" :style="{ marginLeft: sidebarWidth }">
      <PageHeader />
      <div class="content">
        <router-view />
      </div>
    </div>
  </div>

  <router-view v-else />
</template>

<script>
import Sidebar from '@/components/sidebar/Sidebar.vue'
import PageHeader from '@/components/header/PageHeader.vue'
import { sidebarWidth } from '@/components/sidebar/state'

export default {
  components: {
    Sidebar,
    PageHeader
  },

  data() {
    return {
      sidebarWidth
    }
  },

  created() {
    if (sessionStorage.getItem('accessToken')) {
      this.$store.dispatch('checkPermission')
    }
  },

  computed: {
    token() {
      return this.$store.state.token
    }
  },

  watch: {
    $route: {
      immediate: true,
      handler(to) {
        document.title = to.meta.title
            ? this.$t(to.meta.title)
            : import.meta.env.VITE_APP_TITLE
      }
    }
  }
}
</script>

<style scoped>
.layout {
  display: flex;
}

/* главное содержимое */
.main {
  flex: 1;
  min-height: 100vh;
  transition: margin-left 0.3s ease;
  overflow-y: auto;
  position: relative;
}

/* ВАЖНО: убираем залезание на header */
.content {
  padding-top: 30px;
}
</style>